/**
 * Drawer localization schema.
 * Defines all translation strings for the navigation drawer sections and items.
 *
 * @drawer_header @app_name Display name of the application in the drawer header.
 * @drawer_sections @section @title Section title displayed in the drawer (optional in rail mode).
 * @drawer_sections @section @drawer_items @title title Drawer item visible title.
 * @drawer_sections @section @drawer_items @tooltip_text Drawer item tooltip shown on hover.
 */
export default {
  // Group Labels
  laboratory: "Laboratory",

  // Drawer Header
  drawer_header: {
    app_name: "Iris",
  },

  drawer_sections: {
    // Operational Section
    operational_section: {
      // Section Title
      title: "Operational",

      // Operational Items
      drawer_items: {
        channels: {
          title: "Channels",
          tooltip_text: "Monitor and manage instrument connections",
        },
        instruments: {
          title: "Instruments",
          tooltip_text: "Instrument List and Configuration",
        },
        validation: {
          title: "Validation",
          tooltip_text: "Review and validate QC results",
        },
      },
    },

    // Administrative Section
    administrative_section: {
      // Section Title
      title: "Administrative",

      // Administrative Items
      drawer_items: {
        locations: {
          title: "Locations",
          tooltip_text: "Manage physical lab locations",
        },
        instruments: {
          title: "Instruments",
          tooltip_text: "Instrument list and configuration",
        },
      },
    },

    // About Section
    about_section: {
      // About Items
      drawer_items: {
        about: {
          title: "About",
          tooltip_text: "About This Application",
        },
      },
    },
  },
};
